//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'imgTabs',
  data: function data() {
    return {
      check: null,
      count: 0,
      active: {}
    };
  },
  props: {
    option: Object,
    component: Object
  },
  computed: {
    time: function time() {
      return this.option.time;
    }
  },
  watch: {
    count: function count(val) {
      this.active = this.dataChart[val].list;
    },
    dataChart: function dataChart(val) {
      this.active = val && val[0].list;
    },
    time: function time(val) {
      clearInterval(this.check);

      if (val > 0) {
        this.handleTime();
      }
    }
  },
  mounted: function mounted() {
    this.handleTime();
  },
  methods: {
    handleTime: function handleTime() {
      var _this = this;

      this.check = setInterval(function () {
        _this.count++;

        if (_this.count >= _this.dataChart.length) {
          _this.count = 0;
        }
      }, this.time);
    },
    handleItem: function handleItem(index) {
      this.count = index;
    }
  }
};